<p>Are you sure you want to reset the Quick Order?</p>

<div class="actions">
  <button type="button" class="btn btn-outline-primary" (click)="close()">No</button>

  <button type="button" class="btn btn-primary" (click)="reset()">Yes</button>
</div>
